/**
 * 上传文档
 */
import React from 'react';
import { components } from 'common';
const { If } = components;
import umuWebview from '@umu/umu-webview';
import { classSet } from '@umu/umu-dom';
import { LANG } from '../../@utils/webview';
import { FileSelect, IFileSelectProps } from '../fileSelect/fileSelect';
import { useDebounceFn } from 'ahooks';

const ua = umuWebview.UA_INFO;
export function ChooseDoc(props: IFileSelectProps) {
    const { className, children, disabled, onEnd, onData } = props;

    const {run:nativeChooseDoc} =useDebounceFn(() => {
        if (disabled) {
            return;
        }
        umuWebview.registerHandler('receiveFile', (data, _callback) => {
            const fileInfo = data[0];
            if (!!onData) {
                onData('', fileInfo.url, fileInfo.fileName, fileInfo.id);
            }
            if (!!onEnd) {
                onEnd([]);
            }
        });

        umuWebview.callHandler(
            'getFile',
            {
                fileType: 'document',
                fileCount: 1,
            },
            () => {
                // 
            },
            LANG,
        );
    }, {wait: 1000,trailing: false,leading:true});

    const clsNames = classSet('file-select', className || '');
    return (
        <div>
            <If condition={!(ua.isAndroid && ua.isUMUWebview)}>
                <FileSelect {...props} />
            </If>
            <If condition={ua.isAndroid && ua.isUMUWebview}>
                <div className={clsNames} onClick={nativeChooseDoc}>
                    {children}
                </div>
            </If>
        </div>
    );
}
